<div class="router-permission">
    <div class="d-flex info-panel">
        <app-menu-permission [submenuActive]="roleActive" (changeTab)="changeMenuRole($event)"></app-menu-permission>
        <div class="permission-panel-container">
            <app-permission-panel [roleActive]="roleActive"></app-permission-panel>
        </div>
    </div>
</div>